import { DesignComponentBase } from "./SDKDesignComponentBase";
import { resolveComponentPropertyDefinition, } from "./SDKDesignComponentPropertyDefinition";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DesignComponent extends DesignComponentBase {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, sources) {
        var _a, _b;
        super(model, sources);
        this.children = null;
        this.componentPropertyDefinitions = model.componentPropertyDefinitions
            ? resolveComponentPropertyDefinition(model.componentPropertyDefinitions)
            : null;
        this.childrenPersistentIds = (_a = model.childrenPersistentIds) !== null && _a !== void 0 ? _a : null;
        this.isAsset = (_b = model.exportProperties.isAsset) !== null && _b !== void 0 ? _b : null;
    }
}
